import * as Sentry from '@sentry/react';

const IS_LOCAL = process.env.REACT_APP_SENTRY_ENVIRONMENT === 'local';
const IS_ENV_EXIST = !!process.env.REACT_APP_SENTRY_ENVIRONMENT;

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://44a673e962b06d2ba78812d55c9445af@sentry2.dats.tech/131',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['warn', 'error'],
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    // Session Replay
    replaysSessionSampleRate: IS_LOCAL ? 1 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: IS_ENV_EXIST && !IS_LOCAL,
  });
};
